import { DataService } from './dataService'
export const trackingServices = {
	getTrackingList: async (data) => {
		return DataService.get('/admin/get_tracking', data)
	},
    getTrackingDetail: async (data) => {
		return DataService.get('/admin/get_tracking_details', data)
	},
    addTracking: async (data) => {
		return DataService.post('/admin/add_city', data)
	},
    updateTracking: async (data) => {
		return DataService.post('/admin/update_tracking_status', data)
	},
	getTrackingReport: async (data) => {
		return DataService.get('/admin/report/get_tracking', data)
	},
}

export default trackingServices